import { LocalErrorBoundary, ErrorBoundaryProps } from '../../../components/error-boundary/LocalErrorBoundary';
import { useUser } from '../../../app/hooks';

const genericUserMessage: string = 'The data is incompatible with the element configuration';
const genericMessage: string = 'An unexpected error happened';

/**
 * A specialized error boundary for dashboard elements that provides user-friendly error messages based on the user's role.
 */
export const DashboardElementErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children, ...props }) => {
  const { user } = useUser();

  const handleFormatError = (error: any) => {
    if (!error?.userError) return genericMessage;
    if (!user.isOrganizationAdmin) return genericUserMessage;
    return error?.message ?? genericMessage;
  };

  return (
    <LocalErrorBoundary formatError={handleFormatError} {...props}>
      {children}
    </LocalErrorBoundary>
  );
};
